import React from 'react';
import { Button } from './ui/Button';
interface FinalCTAProps {
  onOpenModal: () => void;
}
export function FinalCTA({
  onOpenModal
}: FinalCTAProps) {
  return <section className="py-24 md:py-32 bg-[#FAF8F5] border-t border-brand-divider" data-id="element-97">
      <div className="container px-4 md:px-6 text-center max-w-4xl mx-auto" data-id="element-98">
        <h2 className="font-playfair text-3xl md:text-5xl lg:text-6xl text-brand-text mb-8 leading-tight" data-id="element-99">
          Your even, radiant skin is already there. Let's bring it forward.
        </h2>
        <p className="font-sans text-brand-text/70 text-base md:text-lg mb-10 max-w-2xl mx-auto" data-id="element-100">
          Schedule your complimentary consultation to discuss your skin goals
          and see if BBL Forever Young is right for you.
        </p>
        <Button className="w-full md:w-auto text-sm md:text-base px-10 py-4 min-h-[56px]" onClick={onOpenModal} data-id="element-101">
          Book My Free Consultation
        </Button>
      </div>
    </section>;
}